import getStore from '../store';
import getNextZoomLevel from './getNextZoomLevel';

/**
 * Returns the next zoom and panning values when zooming in or out while keeping
 * the document surface fixed under the given document layer coordinates.
 * @param zoomDelta How many levels of zoom to change. Positive to zoom-in, negative to zoom-out.
 * @param layerX Coordinate in the document layer which will stay fixed.
 * @param layerY Coordinate in the document layer which will stay fixed.
 */
export default function getZoomByWheelValues(zoomDelta: number, layer: { x: number; y: number }) {
    /*
        The relationship between document layer coordinates (Cl)
        and document surface coordinates (Cd) is given by:
        [1]: layerXY = docXY * zoom + panXY

        Therefore the document coordinates under the mouse pointer are:
        [2]: docXY = (layerXY - panXY) / zoom

        As we change the zoom level we need to pan the document in order
        to keep the document coordinates under the same layer coordinates.
        This means that for the two different values of zoom we want layer
        and document coordinates to remain the same and therefore:
        [3]: layerXY == nextLayerXY

        // Expanding and solving for the next panning values we have:
        [4]: docXY * zoom + panXY = docXY * nextZoom + nextPanXY =>
        [5]: nextPanXY = (zoom - nextZoom) * docXY + panXY;
    */
    const { pan, zoom } = getStore();

    const nextZoom = getNextZoomLevel(zoom, zoomDelta);

    const docX = (layer.x - pan.x) / zoom;
    const docY = (layer.y - pan.y) / zoom;

    const nextPanX = (zoom - nextZoom) * docX + pan.x;
    const nextPanY = (zoom - nextZoom) * docY + pan.y;

    return { zoom: nextZoom, x: nextPanX, y: nextPanY };
}
